// @ts-nocheck
// @ts-ignore
/* eslint-disable */
/**
 *
 * SelectCustom
 *
 */

import React, { memo, useEffect, useState } from "react";
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
// import { Link, useHistory } from 'react-router-dom';
// import useDeviceDetect from 'utils/useDeviceDetect';
// styles
// antd component
//import { Card } from 'antd';
//const { Meta } = Card;
// icons
//import CustomIcons from 'components/CustomIcons';
//import defaultUnitImage from 'images/default.jpg';
// components
import { Button, Divider, Select, Skeleton, Space, Tag } from "antd";
import { keys } from "lodash/object";

const { Option } = Select;

/** Normalize multi-select initial value: ObjectId, {_id}, or string → string[] */
function normalizeMultipleSelectValue(val) {
  if (val == null) return [];
  if (!Array.isArray(val)) return [];
  return val
    .map(v => {
      if (v == null) return null;
      if (typeof v === "object" && v._id != null) return String(v._id);
      return String(v);
    })
    .filter(Boolean);
}

// global user
// import { withUser } from 'engine/Contexts/User.context';

function SelectCustom({
  // default props
  className,
  children,
  item,
  listOptions,
  renderExtraSelect = false,
  mode,
  placeholder,
  allowClear,
  disabled,
  refForm,
  showSearch,
  filterOption,
  filterSort,
  optionFilterProp,
  ready,
  ...rest
}) {
  if (ready === false) {
    return <Skeleton />;
  }

  const readInitialSelectedItems = () => {
    if (refForm.current?.saveLocalStorage === true) {
      const storageValues = localStorage.getItem(refForm.current.uniqueFormId);
      if (storageValues !== null) {
        const data = JSON.parse(storageValues);
        if (data[item.name] != null) {
          return normalizeMultipleSelectValue(data[item.name]);
        }
      }
    }
    return normalizeMultipleSelectValue(item.value);
  };

  // Multiple — must seed from item.value or saved institutions are wiped on mount (useEffect below syncs form)
  const [selectedItems, setSelectedItems] = useState(readInitialSelectedItems);

  // Single
  const [selectedItem, setSelectedItem] = useState(null);

  // const filteredOptions = listOptions.filter(
  //   o => !selectedItems.includes(o.key),
  // );

  useEffect(() => {
    if (!refForm?.current) return;
    const formVal = refForm.current.getFieldValue(item.name);
    const same =
      Array.isArray(formVal) &&
      Array.isArray(selectedItems) &&
      formVal.length === selectedItems.length &&
      formVal.every((v, i) => String(v) === String(selectedItems[i]));
    const bothEmpty =
      (formVal == null || (Array.isArray(formVal) && formVal.length === 0)) &&
      selectedItems.length === 0;
    if (same || bothEmpty) return;

    if (item.onChange !== undefined) {
      item.onChange(selectedItems);
    }
    refForm.current.setFieldsValue({ [item.name]: selectedItems });
    // item.onChange intentionally omitted from deps (often unstable inline fns)
  }, [selectedItems, item.name]);

  const tagRender = props => {
    const { value, closable, onClose } = props;
    const onPreventMouseDown = event => {
      event.preventDefault();
      event.stopPropagation();
    };
    const label = listOptions.find(
      i =>
        String(i.key) === String(value) || String(i.value) === String(value),
    )?.label;
    return (
      <Tag
        color={"#eaeaea"}
        closable={closable}
        onClose={onClose}
        style={{
          padding: 3,
          margin: 3,
          fontSize: 16,
          fontWeight: "500",
          color: "black",
        }}
      >
        {label}
      </Tag>
    );
  };

  const selectAll = () => {
    setSelectedItems(listOptions.map(e => e.key));
  };
  const invert = () => {
    let newMap = [];

    newMap = listOptions.filter(o => !selectedItems.includes(o.key));
    setSelectedItems(newMap.map(e => e.key));
  };
  const deselectAll = () => {
    setSelectedItems([]);
  };

  //const { isMobile } = useDeviceDetect();

  return (
    <Select
      placeholder={placeholder}
      optionFilterProp={optionFilterProp}
      filterOption={filterOption}
      filterSort={filterSort}
      mode={mode}
      allowClear={allowClear}
      disabled={disabled}
      showSearch={showSearch}
      value={mode === "multiple" ? selectedItems : selectedItem}
      defaultValue={mode === "multiple" ? selectedItems : selectedItem}
      onDeselect={e => {
        setSelectedItems(selectedItems.filter(o => o !== e));
      }}
      tagRender={tagRender}
      onSelect={newItem => {
        setSelectedItems([...selectedItems, newItem]);
      }}
      onChange={e => {
        const all = { ...refForm.current.getFieldsValue(true), [item.name]: e };
        refForm.current.saveStateToLocalStorage(all);
      }}
      dropdownRender={menu =>
        renderExtraSelect ? (
          <>
            {menu}
            <Divider style={{ margin: "8px 0" }} />

            <Space style={{ padding: "0 8px 4px" }}>
              <Button type="primary" onClick={selectAll}>
                Tout sélectionner
              </Button>
              <Button type="default" onClick={deselectAll}>
                Tout déselectionner
              </Button>
            </Space>
          </>
        ) : (
          menu
        )
      }
    >
      {listOptions.map((option, i) => (
        <Option
          {...option}
          key={option?.key || option?.value}
          value={option?.value || option?.key}
          color={option?.color}
        >
          {option?.label}
        </Option>
      ))}
    </Select>
  );
}

SelectCustom.defaultProps = {};
SelectCustom.propTypes = {};

export default memo(SelectCustom);
